/*global VeloxGridFormAndImporterController, VeloxWebView*/
var uuid = require("uuid") ;
var pkg = require("../../../package.json") ;

var resellerController = new VeloxGridFormAndImporterController("reseller", {
    grid : {
        directory: "views/reseller",
        name: "resellerGrid",
        joinFetch : [
            { otherTable: "velox_user", thisField: "r_code", otherField: "uid", name: "user"}
        ]
    },
    form : {
        directory: "views/reseller",
        name: "resellerForm",
        defaultData : {
            r_create_date : new Date()
        },
        joinFetch : [
            { otherTable: "velox_user", thisField: "r_code", otherField: "uid", name: "user"}
        ]
    },
    importer: {
        name: "resellerImporter",
        openInPopup: true,
        popup: {
            size: "large",
            title: ""
        }
    }
});

resellerController.formController.checkBeforeDelete = function(record, callback){
    return callback(null, false) ;
} ;

/**
 * Delete the realm and user when delete a reseller
 * 
 * @param {object} record the record to delete
 * @param {*} callback 
 */
resellerController.formController.getRecordsToDelete = function(record, callback){
    var records = [];
    if(!record.r_code){ return callback("wrong data") ; }
    this.api.api.multiread({
        customer: {
            search : {r_code: record.r_code}
        },
        call_to_action_trace: {
            search : {r_code: record.r_code}
        },
        extrabat_diag: {
            search : {r_code: record.r_code}
        },
        stats_customer: {
            search : {r_code: record.r_code}
        },
        reseller_settings: {
            search : {r_code: record.r_code}
        }
    }, function(err, reads){
        if(err){ return callback(err) ; }
        for(let c of reads.customer){
            records.push({action : "update", table: "customer", record: { c_id: c.c_id, r_code: null}});
        }
        for(let c of reads.call_to_action_trace){
            c.r_code = null;
            records.push({action : "update", table: "call_to_action_trace", record: c});
        }
        for(let c of reads.extrabat_diag){
            c.r_code = null;
            records.push({action : "update", table: "extrabat_diag", record: c});
        }
        for(let c of reads.stats_customer){
            c.r_code = null;
            records.push({action : "update", table: "stats_customer", record: c});
        }
        for(let c of reads.reseller_settings){
            c.r_code = null;
            records.push({action : "update", table: "reseller_settings", record: c});
        }
        records.push({action : "remove", table: "reseller", record : record}) ;
        records.push({action : "removeWhere", table: "saved_search", record : {r_code: record.r_code}}) ;
        records.push({action : "remove", table: "velox_link_user_realm", record : {user_uid: record.r_code, realm_code: record.r_code}}) ;
        records.push({action : "remove", table: "velox_user", record : {uid: record.r_code}}) ;
        records.push({action : "remove", table: "velox_user_realm", record : {code: record.r_code}}) ;
        callback(null, records) ;
    })
} ;

resellerController.formController.validations.push(function checkCodeUnique(validationData, callback){
    if(resellerController.formController.mode !== "create"){ return callback() ;}
    resellerController.formController.api.api.reseller.searchFirst({r_code: validationData.data.r_code}, function(err, existingReseller){
        if(err){ return callback(err) ;}
        if(existingReseller){
            return callback(VeloxWebView.tr("reseller.aResellerAlreadyExist")) ;
        }
        callback() ;
    }) ;
}) ;

/**
 * Save realm and user when save reseller 
 * 
 * @param {object} viewData the data input by user
 * @param {object} dataBeforeModif the record before user modification
 * @param {*} callback 
 */
resellerController.importerController.getRecordsToSave = 
resellerController.formController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    var records = [] ;

    if(this.mode === "create"){
        records.push({
            table: "reseller", action: "insert", record: viewData
        }) ;
        records.push({
            table: "velox_user_realm", action: "insert", record: {
                code: viewData.r_code, name: viewData.r_name
            }
        }) ;
        records.push({
            table: "velox_user", action: "insert", record: {
                uid: viewData.r_code, 
                login: viewData.r_code, 
                lang: viewData.r_lang, 
                email: viewData.user.email, 
                auth_type: "password", 
                disabled: false, 
                active: false,
                activation_token: uuid.v4(),
                name: viewData.r_name,
                profile_code: "RESELLER"
            }
        }) ;
        records.push({
            table: "velox_link_user_realm", action: "insert", record: {
                user_uid: viewData.r_code, 
                realm_code: viewData.r_code
            }
        }) ;
    } else {
        records.push({
            table: "reseller", action: "update", record: viewData
        }) ;
        records.push({
            table: "velox_user", action: "update", record: {
                uid: viewData.r_code, 
                email: viewData.user.email, 
            }
        }) ;
    }

    callback(null, records) ;
};

resellerController.gridController.onResendMailActive = 
resellerController.formController.onResendMailActive = function(ev){
    var reseller = ev.data.data ;
    var baseUrl = pkg.serverUrl ;

    if(process.env.MODE !== "production"){
        baseUrl = pkg.serverDev ;
        if(process.env.MODE === "test"){
            baseUrl = pkg.serverTest ;
        } else {
            if(process.env.DEVICE === "mobile"){
                baseUrl = pkg.serverDevMobile ;
            }
        }
    }
    VeloxWebView.longTask(function(done){
        VeloxWebView.getLangTr(reseller.r_lang, function(err, trLang){

            var message = trLang("login.activationMessage", {
                link: baseUrl+"/goto?u="+encodeURIComponent("/#activate$"+reseller.user.activation_token),
                link_download: baseUrl+"/goto?u="+encodeURIComponent("/#download")
            });
            if(reseller.r_old_customer){
                message = trLang("login.activationMessageOldCustomer", {
                    link: baseUrl+"/goto?u="+encodeURIComponent("/#activate$"+reseller.user.activation_token),
                    link_download: baseUrl+"/goto?u="+encodeURIComponent("/#download")
                });
            }
            message = '<div style="font-family: Arial; font-size: 11pt">'+message+'</div>' ;

            if(err){ return done(err) ; }
            this.api.api.transactionalChanges(
                [
                    {
                        table : "velox_mail",
                        record: {
                            uid: uuid.v4(),
                            realm_code: reseller.r_code,
                            server_uid: "noreply", 
                            from_addr: "noreply@bayrolsolution.com", 
                            to_addr: reseller.user.email,
                            subject: trLang("login.activationSubject"),
                            text: message,
                            html: message,
                            status: "tosend",
                            schedule_type: "now",
                            html_report: "guide"
                        }
                    }
                ], function(err){
                if(err){ return done(err) ;}
                VeloxWebView.info(VeloxWebView.tr("reseller.mailResent")) ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


resellerController.gridController.onSendMailDownload = 
resellerController.formController.onSendMailDownload = function(ev){
    var reseller = ev.data.data ;
    var baseUrl = pkg.serverUrl ;
    if(process.env.MODE !== "production"){
        baseUrl = pkg.serverDev ;
        if(process.env.MODE === "test"){
            baseUrl = pkg.serverTest ;
        } else {
            if(process.env.DEVICE === "mobile"){
                baseUrl = pkg.serverDevMobile ;
            }
        }
    }
    VeloxWebView.longTask(function(done){
        VeloxWebView.getLangTr(reseller.r_lang, function(err, trLang){
            if(err){ return done(err) ;}
            var message = trLang("login.downloadMessage", {
                link_download: baseUrl+"/#download"
            });
            this.api.api.transactionalChanges(
                [
                    {
                        table : "velox_mail",
                        record: {
                            uid: uuid.v4(),
                            realm_code: reseller.r_code,
                            server_uid: "noreply", 
                            from_addr: "noreply@bayrolsolution.com", 
                            to_addr: reseller.user.email,
                            subject: trLang("login.downloadMessageSubject"),
                            text: message,
                            html: message,
                            status: "tosend",
                            schedule_type: "now",
                            html_report: "guide"
                        }
                    }
                ], function(err){
                if(err){ return done(err) ;}
                VeloxWebView.info(VeloxWebView.tr("reseller.mailSent")) ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

module.exports = resellerController ;